import { render, staticRenderFns } from "./CommunityBusinessnewsReply.vue?vue&type=template&id=61abf673&"
import script from "./CommunityBusinessnewsReply.vue?vue&type=script&lang=js&"
export * from "./CommunityBusinessnewsReply.vue?vue&type=script&lang=js&"
import style0 from "./CommunityBusinessnewsReply.vue?vue&type=style&index=0&id=61abf673&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports